import {
  PDF_VIEWER_INIT,
  PDF_VIEWER_SCROLL,
  PDF_VIEWER_SET_CURRENT_PAGE,
} from '../PDFViewerConstants';

export const DEFAULT_STATE = 0;

const currentPageNumber = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case PDF_VIEWER_INIT:
      return action.viewer.currentPageNumber;
    case PDF_VIEWER_SCROLL:
    case PDF_VIEWER_SET_CURRENT_PAGE:
      return action.currentPageNumber;
    default:
      return state;
  }
};

export default currentPageNumber;



// WEBPACK FOOTER //
// ./src-react/PDFViewer/PDFViewerReducer/currentPageNumber.jsx